<template>
  <el-row
    :gutter="0"
    class="grid"
    type="flex"
    justify="space-between"
    align="middle"
  >
    <el-col :span="1"></el-col>
    <el-col :span="5" class="grid_logo">
      <img src="@/assets/img/logo-1.png" alt=""/>
      <span> 北斗精准服务网</span>
    </el-col>
    <!-- 菜单 -->
    <el-col :span="9" class="grid_menu" >
      <el-breadcrumb separator="">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item :to="{ path: '/Index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/DifferenceCart' }">服务与方案</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Case' }">成功案例</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/NewsCenter' }">资讯广告</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/SoftwareDownload' }">帮助中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Beidou' }">关于我们</el-breadcrumb-item>
        <el-breadcrumb-item></el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <!-- /菜单 -->
    <!-- 服务 -->
    <el-col :span="9" class="grid_search">
      <el-breadcrumb separator=""  class="herder-right-lineHeight">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
<!--        <el-breadcrumb-item>-->
<!--          <i class="el-icon-search"></i>-->
<!--          搜索-->
<!--        </el-breadcrumb-item>-->
        <el-breadcrumb-item :to="{ path: '/ScopeService' }"> <i class="el-icon-search"></i> 服务范围查询</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/FreeTrial' }"><i class="el-icon-timer"/> 免费试用</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/SoftwareDownload' }"><i class="el-icon-download"></i> APP下载</el-breadcrumb-item>
        <el-breadcrumb-item class="login">
          <el-button type="primary" size="mini" @click.native="$router.push('/Login')" v-show="!userInfo" >登录</el-button>
          <el-button type="primary" size="mini" @click.native="$router.push('/Register')" v-show="!userInfo" >注册</el-button>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <el-dropdown trigger="click" @command="commonClick" v-show="userInfo">
          <span class="el-dropdown-link">
            你好，{{userInfo}}<i class="el-icon-caret-top el-icon--right"></i>
          </span>
            <el-dropdown-menu slot="dropdown" v-if="reFresh">
              <el-dropdown-item  v-for="(item,index) in  userMenuList " :key="index" :command="index"  >{{item.name}}</el-dropdown-item>
              <el-dropdown-item  key="12" command="12"  >退出账号</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <!-- /服务 -->
  </el-row>
</template>

<script type="text/javascript">
  import Bus from '@/api/Bus.js'
  // import {loginOut} from '@/api/userService.js'
  import store from '@/store'
  export default {
    name: 'dipperHeaderPage',
    data () {
      return {
        userInfo:'',
        userMenuList:[
        ],
        reFresh:true
      }
    },
    created () {
      this.getUserInfo()
      Bus.$on('watchUser', (w) => {
        // console.log(window.sessionStorage.getItem('userInfo'))
        if(window.sessionStorage.getItem('userInfo')){
          this.userInfo=  JSON.parse(window.sessionStorage.getItem('userInfo')).username
        }else{
          this.userInfo=''
        }
        //this.userInfo=  JSON.parse(window.sessionStorage.getItem('userInfo')).username
      })
      Bus.$on('watchrole', (w) => {
        this.userMenuList = [...this.$store.state.user.role]
      })
    },
    mounted () {
      // this.getUserInfo()
      // this.getRoleList()
      // //this.getRoleList()

      // Bus.$on('watchrole', (w) => {
      //   this.getRoleList()
      // })
    },
    components: {

    },
    watch:{
      'this.$store.getters.role'(){
        this.reFresh = false;
        //console.log('标题强制重新渲染',this.reFresh,'开始')
        this.$nextTick(()=>{
          //console.log('标题强制重新渲染',this.reFresh,'结束')
          this.reFresh = true
        })
      }
    },
    methods: {
      getUserInfo(){
        // let timer = setInterval(()=>{
        //   if(window.sessionStorage.getItem('userInfo') ){
        //     this.userInfo=  JSON.parse(window.sessionStorage.getItem('userInfo')).username
        //    // this.userMenuList = [...this.$store.getters.role]
        //     //console.log(this.userMenuList)
        //     clearInterval(timer)
        //   }else{
        //     this.userInfo = ''
        //     clearInterval(timer)
        //   }
        // },100)
        if(window.sessionStorage.getItem('userInfo')){
          this.userInfo=  JSON.parse(window.sessionStorage.getItem('userInfo')).username
        }else{

        }
        //this.userInfo=  JSON.parse(window.sessionStorage.getItem('userInfo')).username
      },
      getRoleList(){
        let timer = setInterval(()=>{
          this.userMenuList = [...this.$store.getters.role]
          if(this.userMenuList.length != 0){
            clearInterval(timer)
          }
        },100)
      },

      /* 根据用户点击内容进行相应的跳转 */
      commonClick (key) {
        if(key == 0){

          if(this.userMenuList[0].children == null){
            this.$router.push(this.userMenuList[0].urlPath)
          }else{
            this.$router.push(this.userMenuList[0].children[0].urlPath)
          }

        }else if(key == 1){
          if(this.userMenuList[1].children == null){
            this.$router.push(this.userMenuList[1].urlPath)
          }else{
            this.$router.push(this.userMenuList[1].children[0].urlPath)
          }
        }else if(key == 2){
          if(this.userMenuList[2].children == null){
            this.$router.push(this.userMenuList[2].urlPath)
          }else{
            this.$router.push(this.userMenuList[2].children[0].urlPath)
          }
        }else if(key == 3){
          if(this.userMenuList[3].children == null){
            this.$router.push(this.userMenuList[3].urlPath)
          }else{
            this.$router.push(this.userMenuList[3].children[0].urlPath)
          }
        }else if(key == 4){
          if(this.userMenuList[4].children == null){
            this.$router.push(this.userMenuList[4].urlPath)
          }else{
            this.$router.push(this.userMenuList[4].children[0].urlPath)
          }
        }else if(key == 5){
          if(this.userMenuList[5].children == null){
            this.$router.push(this.userMenuList[5].urlPath)
          }else{
            this.$router.push(this.userMenuList[5].children[0].urlPath)
          }

        }else if(key == 12){

          this.$confirm('确定要退出当前账号', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            //loginOut(window.sessionStorage.getItem('token')).then(res => {
            //if(res.data.code == '200'){
            store.dispatch('FedLogOut').then(() => {
              this.$message({
                type: 'success',
                message: '退出成功!'
              })
              this.$store.state.user.role = [];
              this.$store.state.permission.buttonPermission = [];
              window.sessionStorage.removeItem('refreshToken')
              // window.sessionStorage.removeItem('userInfo')
              // window.sessionStorage.removeItem('token')
              Bus.$emit('watchUser')
              this.$router.push('/Login')
            })
            //}
            //}).catch(error => {
            //console.log(error)
            //})
          }).catch((error) => {
            console.log(error)
            this.$message({
              type: 'info',
              message: '取消退出'
            })
          })
        }

        // if (key === '差分帐号') {
        //   // 跳转到 差分账号
        //   this.$router.push('/AccountNumber')
        // }
        // if (key === '费用中心') {
        //   // 跳转到 费用中心
        //   this.$router.push('/Myorder')
        // }
        // if (key === '问题反馈') {
        //   // 跳转到 费用中心
        //   this.$router.push('/Problem')//ProblemFeedback
        // }
        // if (key === '消息中心') {
        //   // 跳转到 费用中心
        //   this.$router.push('/AllNews')
        // }
        // if (key === '用户中心') {
        //   // 跳转到 用户中心
        //   this.$router.push('/Authentication')
        // }
        // if (key === '系统管理') {
        //   // 跳转到 系统管理
        //   this.$router.push('/Menu')
        // }
        // if (key === '退出账号') {
        //   // 跳转到 退出账号
        //   // this.$router.push('/Myorder')
        //   /* 提示用户是否要退出账号 */
        //   this.$confirm('确定要退出当前账号', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     //loginOut(window.sessionStorage.getItem('token')).then(res => {
        //       //if(res.data.code == '200'){
        //         store.dispatch('FedLogOut').then(() => {
        //           this.$message({
        //             type: 'success',
        //             message: '退出成功!'
        //           })
        //           this.$store.state.user.role = [];
        //           this.$store.state.permission.buttonPermission = [];
        //           window.sessionStorage.removeItem('refreshToken')
        //           // window.sessionStorage.removeItem('userInfo')
        //           // window.sessionStorage.removeItem('token')
        //           Bus.$emit('watchUser')
        //           this.$router.push('/Login')
        //         })
        //       //}
        //     //}).catch(error => {
        //       //console.log(error)
        //     //})
        //   }).catch((error) => {
        //     console.log(error)
        //     this.$message({
        //       type: 'info',
        //       message: '取消退出'
        //     })
        //   })
        // }
        // if (key === 'account') {
        //   // 跳转到 账户信息
        //   this.$router.push('/home/account')
        // } else if (key === 'git') {
        //   // 去项目git地址
        //   window.location.href = 'https://github.com/shuiruohanyu/83heimatoutiao'
        // } else {
        //   // 退出
        //   window.localStorage.clear() // 只能清除本项目的所有前端缓存
        //   this.$router.push('/Login') // 跳转到登录页
        // }
      },

    }
  }
</script>

<style lang="less" scoped>
  .grid{
    width: 100%;
    height:80px;
    line-height: 80px;
    background: #082a4c;
    z-index: 100;
    color: #fff;
    /* logo */
    .grid_logo{
      display: flex;
      align-items: center;
      padding-left: 24px;
      font-size: 20px;
      img{
        width:36px;
        height:39px;
      }
      span{
        margin-left: 15px;
        height:19px;
        font-size:20px;
        font-family:Source Han Sans CN;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:19px;
      }
    }
    .el-dropdown:hover , .el-breadcrumb__item {
      cursor:pointer
    }
    .el-dropdown-link  , /deep/ .el-breadcrumb__inner {
      color: #fff;
    }
    /* 菜单 */
    .grid_menu{
      padding-left: 15px;
      .el-breadcrumb__inner{
        width:80px;
        height:16px;
        font-size:16px;
        font-family:Source Han Sans CN;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:7px;
      }
    }
    .grid_search{

      .el-breadcrumb__inner{
        width:27px;
        height:14px;
        font-size:14px;
        font-family:Source Han Sans CN;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:7px;
      }
      .login{
        .el-button{
          padding: 6px;
          margin-top: -8px;
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home-header/home-header.vue